// extracted by mini-css-extract-plugin
export default {"loader":"loading-circle_loader__jxC6h","spin":"loading-circle_spin__iHNQT"};